import React, { useState, useEffect, Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import styled from "styled-components";
import _ from "lodash";
import SavBanner from "../../components/SavBanner";
import { SavInput } from "../../components/Styled";
import LicenseOption from "./LicenseOption";
// import data from "./data.json";
import { save } from 'save-file';

const SavLabel = styled.span`
  font-family:"Gotham-Medium";
  font-size:12px;
  color:#979797;
`;

const SavHeader = styled.div`
  font-family:"Gotham-Medium";
  font-size:16px;
  color:#3f3f3f;
  display: flex;
  align-items:center;
`;

const ProductCard = styled.div`
  padding: 8px;
  font-size: 12px;
  border: 1px solid #b4b4b4;
  border-radius: 8px;
  display:flex;
  align-items: center;
`;
const FileUpload = styled.input`
  color: transparent;
  display: inline-block;
  width: 150px;
  margin-right: 10px;
  &:focus {
    outline:0 none!important;
  }
  &::-webkit-file-upload-button {
    visibility: hidden;
  };
  &::before {
    color:#ff5f00;
    width:150px;
    background-color:#fff;
    text-align:center;
    content: 'LOAD';
    display: inline-block;
    border: 1px solid #ff5f00;
    border-radius: 4px;
    padding: 8px 8px;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    font-size: 10px;
  };
  &:hover::before {
    color: #696057;
    border: 1px solid #696057;
  };
  &:active::before {
    outline: 0 none;
  }
`;

const Component = (props) => {

  const [hostData, setHostData] = useState(null);
  const [optionData, setOptionData] = useState(null);
  const [visibleHosts, setVisibileHosts] = useState(null);
  const [visibleOptionalHosts, setVisibleOptionalHosts] = useState(null);

  const [visibleHost, setVisibleHost] = useState(null);
  const [visibleOptionalHost, setVisibleOptionalHost] = useState(null);

  const [highestLevel, setHighestLevel] = useState(0);
  const [optionLevels, setOptionLevels] = useState({});

  const [jobName, setJobName] = useState('');

  const [showConstruction, setShowConstruction] = useState(false);
  const [wipMsg, setWipMsg] = useState('');
  const [version, setVersion] = useState('');
  const [fileToUpload, setFileToUpload] = useState(null);
  const [uploadData, setUploadData] = useState(null);
  const [setupData, setSetupData] = useState(null);

  const Excel = require('exceljs');
  

  const [data, setData] = useState(null);

  useEffect(() => {
    const REF = localStorage.getItem("ref");
    let dataUrl = '';
    if (REF.includes('savantsystems--uat')){
      dataUrl = 'https://sweb-img.s3.amazonaws.com/Community/platformtool/data-uat.json'
    } else {
      dataUrl = 'https://sweb-img.s3.amazonaws.com/Community/platformtool/data.json'
    }

    fetch(dataUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((jsonData) => setData(jsonData))
      .catch((error) => {
        console.error('Error fetching the JSON file:', error)
        setWipMsg('Under Construction');
        setShowConstruction(true);
      });
  }, []);

  useEffect(() => {
    document.title = "Savant Community | SavantOS Specification Tool"
  },[]);

  useEffect(() => {
    const setup = _.find(data, (d) => d.type === 'setup');
    setSetupData(setup);
    if (setup){
      setVersion(`Version: ${setup.version}, Updated: ${setup.updated}`);
      if (setup.wip === true){
        setShowConstruction(true);
        setWipMsg(setup.wipMsg);
      }
    }

  },[data]);

  useEffect(() => {
    const tempData = _.filter(data, (d) => d.type === "host");
    setHostData(tempData);

    const tempData2 = _.filter(data, (d) => d.type === "option");

    const tempObj = {};

    tempData2.forEach((o) => {
      if (!tempObj[o.label]){
        tempObj[o.label] = 0;
      }
    });
    setOptionLevels(tempObj);

    const groupedData = tempData2.reduce((acc, item) => {
      const { section } = item;
      if (!acc[section]) {
        acc[section] = [];
      }
      acc[section].push(item);
      return acc;
    }, {});
    setOptionData(groupedData);

  },[data]);

  useEffect(() => {
    console.log(optionLevels)
    if (hostData){
      const highestValue = Math.max(...Object.values(optionLevels));
      const hostsFound = _.filter(hostData, (h) => h.hostLevel === highestValue);
      setVisibileHosts(hostsFound);

      const hostFound = _.find(hostData, (h) => h.hostLevel === highestValue);

      if (hostFound){
        setVisibleHost(hostFound);
        if (hostFound.hostLevelUpgrade){
          const upgradeHostFound = _.find(hostData, (h) => h.hostLevel === hostFound.hostLevelUpgrade);
          if (upgradeHostFound){
            setVisibleOptionalHost(upgradeHostFound);
          }
        } else {
          setVisibleOptionalHost(null);
        }
      } else {
        setVisibleHost(null);
        setVisibleOptionalHost(null);
      }
    }
  },[optionLevels, hostData]);

  useEffect(() => {
    if (fileToUpload){
      const wb = new Excel.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(fileToUpload);

      reader.onload = () => {
        const buffer = reader.result;
        wb.xlsx.load(buffer).then(workbook => {
          //console.log(workbook, 'workbook instance');
          const worksheet = workbook.getWorksheet('Options')
          const tempObj = {}

          worksheet.eachRow((row, rowIndex) => {
            if (!tempObj[worksheet.getCell('A' + (rowIndex+1)).value]){
              tempObj[worksheet.getCell('A' + (rowIndex+1)).value] = worksheet.getCell('B' + (rowIndex+1)).value;
            }
          })
          setUploadData(tempObj);
          console.log(tempObj)
        })
      }

    }

  },[fileToUpload])

  const onFileChange = (event) => {
    console.log(event.target.files[0]);
    setFileToUpload(event.target.files[0]);
    setJobName(event.target.files[0].name.replace(".xlsx", ""));
  };

  const handleClick = (e) => {
    e.target.value = null;
  };

  const refreshPage = () => {
    window.location.reload();
  }

  const exportExcel = () => {
    let workbook = new Excel.Workbook();
    workbook.creator = 'Savant Systems, Inc';

    const optionSheet = workbook.addWorksheet('Options');
    const productSheet = workbook.addWorksheet('Products');

    optionSheet.columns = [
      { header: 'Option', key: 'option', width: 60 },
      { header: 'Value', key: 'value', width: 20 },
      { header: 'Level', key: 'level', width: 20 }
    ]
    productSheet.columns = [
      { header: 'Recommended Hosts', key: 'hosts', width: 60},
      { header: 'Required Licenses', key: 'licenses', width: 60},
      { header: 'Required Subscriptions', key: 'subs', width: 60},
    ]

    const tempSkus = ['Recommended Hosts'];
    const tempLicenses = ['Required Licenses'];
    const tempSubs = ['Required Subscriptions'];

    if (visibleHost){
      visibleHost.skus.forEach((sku) => {
        tempSkus.push({text: sku.label, hyperlink: sku.url});
      })
  
      if (visibleHost.osl){
        tempLicenses.push({text: visibleHost.osl.label, hyperlink: visibleHost.osl.url})
      }
  
      if (visibleHost.feature){
        visibleHost.feature.forEach((f) => {

          let optionReqMatchFound = false;
          let overrideFound = false;

          f.optionReqs.forEach((optionReq) => {
            if (optionLevels[optionReq.label] === optionReq.value){
              optionReqMatchFound = true;
            }
          });
  
          f.overrides.forEach((override) => {
            if (optionLevels[override.label] >= override.value ){
              overrideFound = true;
            }
          });
          if (optionReqMatchFound && !overrideFound){
            tempLicenses.push({text: f.label, hyperlink: f.url});
          }
        })
      }
      tempSubs.push(visibleHost.sub.label);
    }
    
    productSheet.getColumn('hosts').values = tempSkus;
    productSheet.getColumn('licenses').values = tempLicenses;
    productSheet.getColumn('subs').values = tempSubs;

    Object.keys(optionLevels).forEach((o, idx) => {
      const row = optionSheet.getRow(idx + 2);
      const optionFound = _.find(data, (od) => od.label === o);
      if (optionFound){
        const valueFound = _.find(optionFound.options, (opt) => opt.hostLevel === optionLevels[o]);
        if (valueFound){
          row.values = {
            option: o,
            level: optionLevels[o],
            value: valueFound.label
          }
        }
      }
    });



    const saveJobBuffer = (buffer) => {
      save(buffer, `${jobName || 'SavantOS Platform Specification'}.xlsx`);
    };
    workbook.xlsx.writeBuffer().then(saveJobBuffer);
  }

  const renderConstruction = () => {
    if (showConstruction){
      return (
        <div className="loaderDiv" style={{marginTop: 60}}>
          <div className="loaderText" style={{width: '100%'}}>
            {wipMsg}
          </div>
        </div>
      )
    }
  };

  const renderOptions = () => {

    const renderJobName = () => {
      return (
        <Col md={6} lg={4}>
          <SavLabel>Job Name (optional)</SavLabel>
          <SavInput value={jobName} onChange={(e) => setJobName(e.target.value)} className="m-b-10" />
        </Col>
      )
    }

    const renderIcon = (section) => {
      if (section === "Project Preferences"){
        return null;
      }
      return <img src={setupData.sectionImages[section]} style={{height: 20, marginRight: 10}} alt='image' />
    }
    if (optionData){
      return (
        <div>
          {Object.keys(optionData).map((section, idx) => {
            return(
              <div key={section}>
                <SavHeader className={idx !== 0 ? "m-t-20" : null}>{renderIcon(section)}{section}</SavHeader>
                <Row style={{alignItems:'end'}}>
                  {idx === 0 ? renderJobName() : null}
                  {optionData[section].map((option) => {
                    return <LicenseOption option={option} setOptionLevels={setOptionLevels} optionLevels={optionLevels} uploadData={uploadData} key={option.label} />
                  })}
                </Row>
              </div>
            )
          })}
        </div>
      )
    }
  };

  const renderHosts = () => {

    let activeFeatureLicenses = [];

    const renderFeatureLicense =(featureLicenses) => {
      if (!_.isEmpty(featureLicenses)){

       return featureLicenses.map((featureLicense) => {
        let optionReqMatchFound = false;
        let overrideFound = false;

        // if one of the optionLevels is found in featureLicense.optionReqs
        // if the found optionReq.value is === optionLevel.value, optionReqMatchFound = true
        featureLicense.optionReqs.forEach((optionReq) => {
          if (optionLevels[optionReq.label] === optionReq.value){
            optionReqMatchFound = true;
          }
        });

        featureLicense.overrides.forEach((override) => {
          if (optionLevels[override.label] >= override.value ){
            overrideFound = true;
          }
        });

        if (optionReqMatchFound && !overrideFound){
          activeFeatureLicenses.push(featureLicense.label);
          return (
            <ProductCard style={{marginTop:10}} key={featureLicense.label}>
              <img src={featureLicense.img} alt="img" style={{height: 40, marginRight: 10}}/>
              <div>
                <div className="book f12">
                  {featureLicense.label}
                </div>
                <div>
                  <a href={featureLicense.url} target="_blank" rel="noreferrer" className="med oj f12">
                    View in Store
                  </a>
                  
                </div>
              </div>
            </ProductCard>
          )
        }
        return null;
       })

      }
    }

    const renderProduct = (prod) => {
      if (prod){
        return (
          <ProductCard style={{marginTop:10}} key={prod.label}>
            <img src={prod.img} alt="img" style={{height: 40, marginRight: 10}}/>
            <div>
              <div className="book f12">
                {prod.label}
              </div>
              <div>
                <a href={prod.url} target="_blank" rel="noreferrer" className="med oj f12">
                  View in Store
                </a>
                
              </div>
            </div>
          </ProductCard>
        )
      }
      return null;
    }
    const renderKitProduct = (prod) => {
      if (prod){
        return (
          <ProductCard style={{marginTop:10}} key={prod.label}>
            <img src={prod.img} alt="img" style={{height: 75, marginRight: 15}}/>
            <div>
              <div className="med f12">
                {prod.label}
              </div>
              <div className="book f12">
                {prod.description}
              </div>
              <div>
                <a href={prod.url} target="_blank" rel="noreferrer" className="med oj f12">
                  View in Store
                </a>
                
              </div>
            </div>
          </ProductCard>
        )
      }
      return null;
    }

    const renderKits = (h) => {

      if(h.kits){
        let kitFound = _.find(h.kits, (kit) => !kit.feature);

        if (!_.isEmpty(activeFeatureLicenses)){
          h.kits.forEach((kit) => {
            if (kit.feature){
              if (activeFeatureLicenses.includes(kit.feature)){
                kitFound = kit;
              }
            }
          });
        }

        if (kitFound){

          const renderNotIncludedFeature =() => {

            const nonKitFeatures = _.filter(h.feature, (feature) => feature.label !== kitFound.feature && activeFeatureLicenses.includes(feature.label));
            
            return nonKitFeatures.map((f) => {
              return renderProduct(f)
            })
          }

          return (
            <Fragment>
              <Col xs={12} className="m-t-20">RECOMMENDED KIT</Col>
              <Col md={6}>
                {renderKitProduct(kitFound)}
              </Col>
              <Col md={3}>
              {renderNotIncludedFeature(kitFound)}
              </Col>
              <Col md={3}>
                {renderProduct(h.sub)}
              </Col>
            </Fragment>
          )
        }

      }


      // if (h.kits){
      //   return (
      //     <Fragment>
      //       <Col xs={12} className="m-t-20">RECOMMENDED KIT</Col>
      //       {h.kits.map((kit) => {
      //         return (
      //           <Col md={6}>
      //             {renderKitProduct(kit)}
      //           </Col>
      //         )
      //       })}
      //     </Fragment>
      //   )
      // }
      return null;
    }

    if (visibleHost){
      return (
        <Row className="m-t-40">
          <Col xs={12}>RECOMMENDED SAVANTOS PLATFORM</Col>
          <Col lg={3} md={6}>
            <div className="med f12 m-b-10 m-t-10">Hosts</div>
            {visibleHost.skus.map((s) => {
              return renderProduct(s)
            })}
          </Col>
          <Col lg={3} md={6}>
            <div className="med f12 m-b-10 m-t-10">Required OSL License</div>
            {renderProduct(visibleHost.osl)}
          </Col>
          <Col lg={3} md={6}>
            <div className="med f12 m-b-10 m-t-10">Required Feature License(s)</div>
            {renderFeatureLicense(visibleHost.feature)}
          </Col>
          <Col lg={3} md={6}>
            <div className="med f12 m-b-10 m-t-10">Required Subscription</div>
            {renderProduct(visibleHost.sub)}
          </Col>
          {renderKits(visibleHost)}
        </Row>
      )
    }
  };

  const renderOptionalHosts = () => {

    const renderFeatureLicense =(featureLicenses) => {
      if (!_.isEmpty(featureLicenses)){

       return featureLicenses.map((featureLicense) => {
        let optionReqMatchFound = false;
        let overrideFound = false;

        // if one of the optionLevels is found in featureLicense.optionReqs
        // if the found optionReq.value is === optionLevel.value, optionReqMatchFound = true
        featureLicense.optionReqs.forEach((optionReq) => {
          if (optionLevels[optionReq.label] === optionReq.value){
            optionReqMatchFound = true;
          }
        });
        //&& override.minHostLevel <= Math.max(...Object.values(optionLevels))

        featureLicense.overrides.forEach((override) => {
          if (optionLevels[override.label] >= override.value ){
            overrideFound = true;
          }
        });

        if (optionReqMatchFound && !overrideFound){
          return (
            <ProductCard style={{marginTop:10}} key={featureLicense.label}>
              <img src={featureLicense.img} alt="img" style={{height: 40, marginRight: 10}}/>
              <div>
                <div className="book f12">
                  {featureLicense.label}
                </div>
                <div>
                  <a href={featureLicense.url} target="_blank" rel="noreferrer" className="med oj f12">
                    View in Store
                  </a>
                  
                </div>
              </div>
            </ProductCard>
          )
        }
        return null;
       })

      }
    }

    const renderProduct = (prod) => {
      if (prod){
        return (
          <ProductCard style={{marginTop:10}} key={prod.label}>
            <img src={prod.img} alt="img" style={{height: 40, marginRight: 10}}/>
            <div>
              <div className="book f12 truncate">
                {prod.label}
              </div>
              <div>
                <a href={prod.url} target="_blank" rel="noreferrer" className="med oj f12">
                  View in Store
                </a>
                
              </div>
            </div>
          </ProductCard>
        )
      }
      return null;
    }

    if (visibleOptionalHost){
      return (
        <Fragment>
          <hr />
          <Row key={visibleOptionalHost.label} className="m-t-40">
            <Col xs={12}>UPGRADED PLATFORM OPTIONS</Col>
            <Col lg={3} md={6}>
              <div className="med f12 m-b-10 m-t-10">Hosts</div>
              {visibleOptionalHost.skus.map((s) => {
                return renderProduct(s)
              })}
            </Col>
            <Col lg={3} md={6}>
              <div className="med f12 m-b-10 m-t-10">OSL License</div>
              {renderProduct(visibleOptionalHost.osl)}
            </Col>
            <Col lg={3} md={6}>
              <div className="med f12 m-b-10 m-t-10">Feature License(s)</div>
              {renderFeatureLicense(visibleOptionalHost.feature)}
            </Col>
            <Col lg={3} md={6}>
              <div className="med f12 m-b-10 m-t-10">Subscription</div>
              {renderProduct(visibleOptionalHost.sub)}
            </Col>
          </Row>
        </Fragment>
      )
    }

    // if (visibleOptionalHosts){
    //   return visibleOptionalHosts.map((h) => {
    //     return (
    //       <Fragment>
    //         <hr />
    //         <Row key={h.label} className="m-t-40">
    //           <Col xs={12}>UPGRADED PLATFORM OPTIONS</Col>
    //           <Col lg={3} md={6}>
    //             <div className="med f12 m-b-10 m-t-10">Hosts</div>
    //             {h.skus.map((s) => {
    //               return renderProduct(s)
    //             })}
    //           </Col>
    //           <Col lg={3} md={6}>
    //             <div className="med f12 m-b-10 m-t-10">OSL License</div>
    //             {renderProduct(h.osl)}
    //           </Col>
    //           <Col lg={3} md={6}>
    //             <div className="med f12 m-b-10 m-t-10">Feature License(s)</div>
    //             {renderFeatureLicense(h.feature)}
    //           </Col>
    //           <Col lg={3} md={6}>
    //             <div className="med f12 m-b-10 m-t-10">Subscription</div>
    //             {renderProduct(h.sub)}
    //           </Col>
    //         </Row>
    //       </Fragment>
          
    //     )
    //   })
    // }
  };

  return (
    <div>
      <SavBanner text="SavantOS Specification Tool" padding="40px" />
      <Container className="m-t-40">

        <div className="text-center book f12 m-t-20 m-b-20">
          Savant is the operating system of the home and delivers enhanced performance and functionality as it scales to meet the needs of any project. This specification tool provides a suggested minimum platform of Savant Host, Base License, and Essentials Subscription based on the scope of your project, as well as options for upgraded performance. Please refer to the  <a href="/knowledge/Savant-Host-Feature-Support-Matrix" target="_blank" rel="noreferrer" className="med oj f12">Savant Host Feature Matrix</a> for further information on system capabilities.
        </div>
        {renderConstruction()}
        {renderOptions()}
        <hr />
        <div className="text-center book f12 m-t-20 m-b-20">
          All results of this specification tool are recommendations based on user input. Please complete all fields for the most accurate recommendation. Refer to the <a href="/knowledge/Savant-Host-Feature-Support-Matrix" target="_blank" rel="noreferrer" className="med oj f12">Savant Host Feature Matrix</a> for detailed information on system capabilities.
        </div>
        {renderHosts()}
        {renderOptionalHosts()}
        {/* {renderHostGrid()} */}
        

        <div className='text-center m-t-40'>
          <button className="sav-btn__gray" onClick={() => refreshPage()} style={{marginRight: 10}}>Clear</button>
          <FileUpload type="file" onChange={onFileChange} onClick={(e) => handleClick(e)} />
          <button className="sav-btn__orange--fill" onClick={() => exportExcel()}>Save</button>
        </div>
        <div className='book f8 text-right light-gray m-t-20'>
          {version}
        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    state: null
  };
};
export default connect(mapStateToProps)(Component);
